module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('DashboardLayout', [_c('template', {
    slot: "navbarFilters"
  }, [(_vm.hasWorldStore && !_vm.loadingApiData) ? _c('div', {
    staticClass: "navbar-filters"
  }, [(_vm.sellerAccountsList && _vm.sellerAccountsList.length > 0) ? _c('div', {
    ref: "saDropdown",
    staticClass: "ui dropdown filter-dropdown navbar-dropdown"
  }, [_c('div', {
    staticClass: "dropdown-trigger"
  }, [_c('span', {
    staticClass: "text"
  }, [_vm._v("S.Accounts: " + _vm._s(_vm.filterBySellAcc.length === 0 ? 'All' : _vm.filterBySellAcc.length + ' selected'))]), _vm._v(" "), _c('i', {
    staticClass: "dropdown icon"
  })]), _vm._v(" "), _c('div', {
    staticClass: "menu"
  }, [_c('div', {
    staticClass: "item",
    class: {
      selected: _vm.filterBySellAcc.length === 0
    },
    attrs: {
      "data-value": ""
    }
  }, [(_vm.filterBySellAcc.length === 0) ? _c('i', {
    staticClass: "check icon"
  }) : _vm._e(), _vm._v("\n            All\n          ")]), _vm._v(" "), _c('div', {
    staticClass: "divider"
  }), _vm._v(" "), _vm._l((_vm.sellerAccountsList), function(sa) {
    return _c('div', {
      key: sa.sellerId,
      staticClass: "item",
      class: {
        selected: _vm.filterBySellAcc.indexOf(sa.sellerId) >= 0
      },
      attrs: {
        "data-value": sa.sellerId
      }
    }, [(_vm.filterBySellAcc.indexOf(sa.sellerId) >= 0) ? _c('i', {
      staticClass: "check icon"
    }) : _vm._e(), _vm._v("\n            " + _vm._s(sa.accountNickName) + "\n          ")])
  })], 2)]) : _vm._e(), _vm._v(" "), (_vm.filterUserCountries && _vm.filterUserCountries.length > 0) ? _c('div', {
    ref: "marketplaceDropdown",
    staticClass: "ui dropdown filter-dropdown navbar-dropdown"
  }, [_c('div', {
    staticClass: "dropdown-trigger"
  }, [_c('span', {
    staticClass: "text"
  }, [_vm._v("Marketplaces: " + _vm._s(_vm.filterByMarket.length === 0 ? 'All' : _vm.filterByMarket.length === 1 ? _vm.filterByMarket[0] : _vm.filterByMarket.length + ' selected'))]), _vm._v(" "), _c('i', {
    staticClass: "dropdown icon"
  })]), _vm._v(" "), _c('div', {
    staticClass: "menu"
  }, [_c('div', {
    staticClass: "item",
    class: {
      selected: _vm.filterByMarket.length === 0
    },
    attrs: {
      "data-value": ""
    }
  }, [(_vm.filterByMarket.length === 0) ? _c('i', {
    staticClass: "check icon"
  }) : _vm._e(), _vm._v("\n            All\n          ")]), _vm._v(" "), _c('div', {
    staticClass: "divider"
  }), _vm._v(" "), _vm._l((_vm.filteredCountries), function(c) {
    return _c('div', {
      key: c,
      class: [c == 's' ? 'divider' : 'item', {
        selected: _vm.filterByMarket.indexOf(c) >= 0 && c !== 's'
      }],
      attrs: {
        "data-value": c
      }
    }, [(_vm.filterByMarket.indexOf(c) >= 0 && c !== 's') ? _c('i', {
      staticClass: "check icon"
    }) : _vm._e(), _vm._v(" "), (c != 's') ? _c('i', {
      class: c.toLowerCase().replace('uk', 'gb') + ' flag',
      staticStyle: {
        "margin-right": "8px"
      }
    }) : _vm._e(), _vm._v(" "), (c != 's') ? _c('span', [_vm._v("Amazon." + _vm._s(_vm.getMarketplaceSuffix(c)))]) : _vm._e()])
  })], 2)]) : _vm._e()]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "products-page"
  }, [_c('div', {
    staticClass: "products-content"
  }, [(_vm.hasWorldStore && !_vm.loadingApiData) ? _c('div', {
    staticClass: "toolbar"
  }, [_c('div', {
    staticClass: "toolbar-title-group"
  }, [_c('span', {
    staticClass: "toolbar-title"
  }, [_vm._v("Products")]), _vm._v(" "), _c('span', {
    staticClass: "stat-pill total"
  }, [_vm._v(_vm._s(_vm.totalProducts) + " total")]), _vm._v(" "), _c('span', {
    staticClass: "stat-pill cogs-ok"
  }, [_vm._v(_vm._s(_vm.cogsSetCount) + " COGS set")]), _vm._v(" "), _c('span', {
    staticClass: "stat-pill cogs-missing"
  }, [_vm._v(_vm._s(_vm.cogsMissingCount) + " missing")])]), _vm._v(" "), _c('div', {
    staticClass: "toolbar-gap"
  }), _vm._v(" "), _c('div', {
    staticClass: "search-wrap"
  }, [_c('span', {
    staticClass: "search-icon"
  }, [_c('svg', {
    attrs: {
      "viewBox": "0 0 24 24",
      "fill": "none",
      "stroke": "currentColor",
      "stroke-width": "2"
    }
  }, [_c('circle', {
    attrs: {
      "cx": "11",
      "cy": "11",
      "r": "8"
    }
  }), _c('path', {
    attrs: {
      "d": "M21 21l-4.35-4.35"
    }
  })])]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.asinSearch),
      expression: "asinSearch"
    }, {
      name: "prevent-autofill",
      rawName: "v-prevent-autofill",
      value: (_vm.asinSearch),
      expression: "asinSearch"
    }],
    staticClass: "search-input",
    attrs: {
      "type": "search",
      "placeholder": "Search products or ASIN…"
    },
    domProps: {
      "value": (_vm.asinSearch)
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.handleAsinSearch.apply(null, arguments)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.asinSearch = $event.target.value
      }
    }
  }), _vm._v(" "), (_vm.asinSearch) ? _c('i', {
    staticClass: "times circle icon clear-search",
    on: {
      "click": _vm.clearAsinSearch
    }
  }) : _vm._e()]), _vm._v(" "), _c('button', {
    staticClass: "quick-filter",
    class: {
      active: _vm.filterByBuyBox
    },
    on: {
      "click": _vm.toggleBuyBoxFilter
    }
  }, [_vm._v("\n        Buy Box: All\n      ")]), _vm._v(" "), _c('button', {
    staticClass: "quick-filter",
    class: {
      active: _vm.filterMissingCogs
    },
    on: {
      "click": _vm.toggleMissingCogsFilter
    }
  }, [_vm._v("\n        Missing COGS "), _c('span', {
    staticClass: "qf-count"
  }, [_vm._v(_vm._s(_vm.cogsMissingCount))])]), _vm._v(" "), _c('button', {
    staticClass: "btn-import",
    on: {
      "click": _vm.handleImportCogs
    }
  }, [_c('svg', {
    attrs: {
      "viewBox": "0 0 24 24",
      "fill": "none",
      "stroke": "currentColor",
      "stroke-width": "2"
    }
  }, [_c('path', {
    attrs: {
      "d": "M4 16v1a3 3 0 003 3h10a3 3 0 003-3v-1"
    }
  }), _c('polyline', {
    attrs: {
      "points": "7 10 12 15 17 10"
    }
  }), _c('line', {
    attrs: {
      "x1": "12",
      "y1": "15",
      "x2": "12",
      "y2": "3"
    }
  })]), _vm._v("\n        Import COGS\n      ")]), _vm._v(" "), _c('div', {
    staticClass: "view-toggle"
  }, [_c('button', {
    staticClass: "view-btn",
    class: {
      active: _vm.viewMode === 'grid'
    },
    attrs: {
      "title": "Grid view"
    },
    on: {
      "click": function($event) {
        _vm.viewMode = 'grid'
      }
    }
  }, [_c('svg', {
    attrs: {
      "viewBox": "0 0 24 24",
      "fill": "none",
      "stroke": "currentColor",
      "stroke-width": "2"
    }
  }, [_c('rect', {
    attrs: {
      "x": "3",
      "y": "3",
      "width": "7",
      "height": "7",
      "rx": "1"
    }
  }), _c('rect', {
    attrs: {
      "x": "14",
      "y": "3",
      "width": "7",
      "height": "7",
      "rx": "1"
    }
  }), _c('rect', {
    attrs: {
      "x": "3",
      "y": "14",
      "width": "7",
      "height": "7",
      "rx": "1"
    }
  }), _c('rect', {
    attrs: {
      "x": "14",
      "y": "14",
      "width": "7",
      "height": "7",
      "rx": "1"
    }
  })])]), _vm._v(" "), _c('button', {
    staticClass: "view-btn",
    class: {
      active: _vm.viewMode === 'table'
    },
    attrs: {
      "title": "Table view"
    },
    on: {
      "click": function($event) {
        _vm.viewMode = 'table'
      }
    }
  }, [_c('svg', {
    attrs: {
      "viewBox": "0 0 24 24",
      "fill": "none",
      "stroke": "currentColor",
      "stroke-width": "2"
    }
  }, [_c('line', {
    attrs: {
      "x1": "3",
      "y1": "6",
      "x2": "21",
      "y2": "6"
    }
  }), _c('line', {
    attrs: {
      "x1": "3",
      "y1": "12",
      "x2": "21",
      "y2": "12"
    }
  }), _c('line', {
    attrs: {
      "x1": "3",
      "y1": "18",
      "x2": "21",
      "y2": "18"
    }
  })])])])]) : _vm._e()]), _vm._v(" "), _c('div', {
    key: "2",
    staticClass: "ui fluid container",
    attrs: {
      "id": "prodCont"
    }
  }, [(_vm.loadingApiData || !_vm.hasWorldStore) ? _c('div', {
    staticClass: "ui active centered inline loader",
    staticStyle: {
      "margin": "50px 0"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.apiError && !_vm.loadingApiData) ? _c('div', {
    staticClass: "ui error message",
    staticStyle: {
      "margin": "20px 0"
    }
  }, [_c('div', {
    staticClass: "header"
  }, [_vm._v("Failed to Load Products")]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.apiError))]), _vm._v(" "), _c('button', {
    staticClass: "ui button",
    on: {
      "click": function($event) {
        return _vm.loadProductsFromBackend()
      }
    }
  }, [_vm._v("Retry")])]) : _vm._e(), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "fadeLeft",
      "mode": "out-in",
      "appear": ""
    }
  }, [(_vm.productData && _vm.productData.products && Object.keys(_vm.productData.products).length > 0 && _vm.viewMode === 'grid' && !_vm.loadingApiData) ? _c('ProductCard', {
    key: 'grid-' + _vm.gridCurrentPage,
    ref: "productCard",
    attrs: {
      "worldStore": _vm.productData,
      "filterByMarket": _vm.filterByMarket,
      "filterBySellAcc": _vm.filterBySellAcc,
      "filterMissingCogs": _vm.filterMissingCogs
    },
    on: {
      "open-product-details": _vm.showProductDetails,
      "cogs-updated": _vm.handleCogsUpdated
    }
  }) : _vm._e()], 1), _vm._v(" "), (_vm.productData && _vm.productData.products && Object.keys(_vm.productData.products).length > 0 && _vm.viewMode === 'table' && !_vm.loadingApiData) ? _c('div', {
    staticClass: "table-view",
    attrs: {
      "id": "tableView"
    }
  }, [_c('div', {
    staticClass: "products-table-wrap"
  }, [_c('table', [_c('thead', [_c('tr', [_c('th', {
    staticClass: "th-img"
  }), _vm._v(" "), _c('th', {
    staticClass: "th-sort"
  }, [_c('span', {
    staticClass: "sort-col-head",
    class: _vm.tableSortHeadClass('product'),
    attrs: {
      "role": "button",
      "tabindex": "0",
      "title": "Sort by product name or ASIN"
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.toggleTableSort('product')
      },
      "keydown": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        $event.preventDefault();
        return _vm.toggleTableSort('product')
      }
    }
  }, [_vm._v("Product / ASIN"), _c('span', {
    staticClass: "sort-col-icons",
    attrs: {
      "aria-hidden": "true"
    }
  }, [(_vm.tableSortKey === 'product' && _vm.tableSortDir === 'asc') ? _c('svg', {
    staticClass: "sort-icon-filled",
    attrs: {
      "viewBox": "0 0 24 24"
    }
  }, [_c('path', {
    attrs: {
      "fill": "currentColor",
      "d": "M12 8l7 9H5z"
    }
  })]) : (_vm.tableSortKey === 'product' && _vm.tableSortDir === 'desc') ? _c('svg', {
    staticClass: "sort-icon-filled",
    attrs: {
      "viewBox": "0 0 24 24"
    }
  }, [_c('path', {
    attrs: {
      "fill": "currentColor",
      "d": "M12 16l-7-9h14z"
    }
  })]) : _c('svg', {
    staticClass: "sort-icon-neutral",
    attrs: {
      "viewBox": "0 0 24 24",
      "fill": "none",
      "stroke": "currentColor",
      "stroke-width": "2"
    }
  }, [_c('path', {
    attrs: {
      "d": "M7 15l5 5 5-5M7 9l5-5 5 5"
    }
  })])])])]), _vm._v(" "), _c('th', {
    staticClass: "th-sort"
  }, [_c('span', {
    staticClass: "sort-col-head",
    class: _vm.tableSortHeadClass('buyBox'),
    attrs: {
      "role": "button",
      "tabindex": "0",
      "title": "Sort by Buy Box status"
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.toggleTableSort('buyBox')
      },
      "keydown": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        $event.preventDefault();
        return _vm.toggleTableSort('buyBox')
      }
    }
  }, [_vm._v("Buy Box"), _c('span', {
    staticClass: "sort-col-icons",
    attrs: {
      "aria-hidden": "true"
    }
  }, [(_vm.tableSortKey === 'buyBox' && _vm.tableSortDir === 'asc') ? _c('svg', {
    staticClass: "sort-icon-filled",
    attrs: {
      "viewBox": "0 0 24 24"
    }
  }, [_c('path', {
    attrs: {
      "fill": "currentColor",
      "d": "M12 8l7 9H5z"
    }
  })]) : (_vm.tableSortKey === 'buyBox' && _vm.tableSortDir === 'desc') ? _c('svg', {
    staticClass: "sort-icon-filled",
    attrs: {
      "viewBox": "0 0 24 24"
    }
  }, [_c('path', {
    attrs: {
      "fill": "currentColor",
      "d": "M12 16l-7-9h14z"
    }
  })]) : _c('svg', {
    staticClass: "sort-icon-neutral",
    attrs: {
      "viewBox": "0 0 24 24",
      "fill": "none",
      "stroke": "currentColor",
      "stroke-width": "2"
    }
  }, [_c('path', {
    attrs: {
      "d": "M7 15l5 5 5-5M7 9l5-5 5 5"
    }
  })])])])]), _vm._v(" "), _c('th', {
    staticClass: "th-sort"
  }, [_c('span', {
    staticClass: "sort-col-head",
    class: _vm.tableSortHeadClass('rating'),
    attrs: {
      "role": "button",
      "tabindex": "0",
      "title": "Sort by star rating"
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.toggleTableSort('rating')
      },
      "keydown": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        $event.preventDefault();
        return _vm.toggleTableSort('rating')
      }
    }
  }, [_vm._v("Rating"), _c('span', {
    staticClass: "sort-col-icons",
    attrs: {
      "aria-hidden": "true"
    }
  }, [(_vm.tableSortKey === 'rating' && _vm.tableSortDir === 'asc') ? _c('svg', {
    staticClass: "sort-icon-filled",
    attrs: {
      "viewBox": "0 0 24 24"
    }
  }, [_c('path', {
    attrs: {
      "fill": "currentColor",
      "d": "M12 8l7 9H5z"
    }
  })]) : (_vm.tableSortKey === 'rating' && _vm.tableSortDir === 'desc') ? _c('svg', {
    staticClass: "sort-icon-filled",
    attrs: {
      "viewBox": "0 0 24 24"
    }
  }, [_c('path', {
    attrs: {
      "fill": "currentColor",
      "d": "M12 16l-7-9h14z"
    }
  })]) : _c('svg', {
    staticClass: "sort-icon-neutral",
    attrs: {
      "viewBox": "0 0 24 24",
      "fill": "none",
      "stroke": "currentColor",
      "stroke-width": "2"
    }
  }, [_c('path', {
    attrs: {
      "d": "M7 15l5 5 5-5M7 9l5-5 5 5"
    }
  })])])])]), _vm._v(" "), _c('th', {
    staticClass: "th-sort"
  }, [_c('span', {
    staticClass: "sort-col-head",
    class: _vm.tableSortHeadClass('salesYesterday'),
    attrs: {
      "role": "button",
      "tabindex": "0",
      "title": "Sort by units sold yesterday"
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.toggleTableSort('salesYesterday')
      },
      "keydown": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        $event.preventDefault();
        return _vm.toggleTableSort('salesYesterday')
      }
    }
  }, [_vm._v("Sales (ystd.)"), _c('span', {
    staticClass: "sort-col-icons",
    attrs: {
      "aria-hidden": "true"
    }
  }, [(_vm.tableSortKey === 'salesYesterday' && _vm.tableSortDir === 'asc') ? _c('svg', {
    staticClass: "sort-icon-filled",
    attrs: {
      "viewBox": "0 0 24 24"
    }
  }, [_c('path', {
    attrs: {
      "fill": "currentColor",
      "d": "M12 8l7 9H5z"
    }
  })]) : (_vm.tableSortKey === 'salesYesterday' && _vm.tableSortDir === 'desc') ? _c('svg', {
    staticClass: "sort-icon-filled",
    attrs: {
      "viewBox": "0 0 24 24"
    }
  }, [_c('path', {
    attrs: {
      "fill": "currentColor",
      "d": "M12 16l-7-9h14z"
    }
  })]) : _c('svg', {
    staticClass: "sort-icon-neutral",
    attrs: {
      "viewBox": "0 0 24 24",
      "fill": "none",
      "stroke": "currentColor",
      "stroke-width": "2"
    }
  }, [_c('path', {
    attrs: {
      "d": "M7 15l5 5 5-5M7 9l5-5 5 5"
    }
  })])])])]), _vm._v(" "), _c('th', {
    staticClass: "th-sort"
  }, [_c('span', {
    staticClass: "sort-col-head",
    class: _vm.tableSortHeadClass('salesToday'),
    attrs: {
      "role": "button",
      "tabindex": "0",
      "title": "Sort by units sold today"
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.toggleTableSort('salesToday')
      },
      "keydown": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        $event.preventDefault();
        return _vm.toggleTableSort('salesToday')
      }
    }
  }, [_vm._v("Sales (today)"), _c('span', {
    staticClass: "sort-col-icons",
    attrs: {
      "aria-hidden": "true"
    }
  }, [(_vm.tableSortKey === 'salesToday' && _vm.tableSortDir === 'asc') ? _c('svg', {
    staticClass: "sort-icon-filled",
    attrs: {
      "viewBox": "0 0 24 24"
    }
  }, [_c('path', {
    attrs: {
      "fill": "currentColor",
      "d": "M12 8l7 9H5z"
    }
  })]) : (_vm.tableSortKey === 'salesToday' && _vm.tableSortDir === 'desc') ? _c('svg', {
    staticClass: "sort-icon-filled",
    attrs: {
      "viewBox": "0 0 24 24"
    }
  }, [_c('path', {
    attrs: {
      "fill": "currentColor",
      "d": "M12 16l-7-9h14z"
    }
  })]) : _c('svg', {
    staticClass: "sort-icon-neutral",
    attrs: {
      "viewBox": "0 0 24 24",
      "fill": "none",
      "stroke": "currentColor",
      "stroke-width": "2"
    }
  }, [_c('path', {
    attrs: {
      "d": "M7 15l5 5 5-5M7 9l5-5 5 5"
    }
  })])])])]), _vm._v(" "), _c('th', {
    staticClass: "th-sort"
  }, [_c('span', {
    staticClass: "sort-col-head",
    class: _vm.tableSortHeadClass('cogs'),
    attrs: {
      "role": "button",
      "tabindex": "0",
      "title": "Sort by COGS"
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.toggleTableSort('cogs')
      },
      "keydown": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        $event.preventDefault();
        return _vm.toggleTableSort('cogs')
      }
    }
  }, [_vm._v("COGS"), _c('span', {
    staticClass: "sort-col-icons",
    attrs: {
      "aria-hidden": "true"
    }
  }, [(_vm.tableSortKey === 'cogs' && _vm.tableSortDir === 'asc') ? _c('svg', {
    staticClass: "sort-icon-filled",
    attrs: {
      "viewBox": "0 0 24 24"
    }
  }, [_c('path', {
    attrs: {
      "fill": "currentColor",
      "d": "M12 8l7 9H5z"
    }
  })]) : (_vm.tableSortKey === 'cogs' && _vm.tableSortDir === 'desc') ? _c('svg', {
    staticClass: "sort-icon-filled",
    attrs: {
      "viewBox": "0 0 24 24"
    }
  }, [_c('path', {
    attrs: {
      "fill": "currentColor",
      "d": "M12 16l-7-9h14z"
    }
  })]) : _c('svg', {
    staticClass: "sort-icon-neutral",
    attrs: {
      "viewBox": "0 0 24 24",
      "fill": "none",
      "stroke": "currentColor",
      "stroke-width": "2"
    }
  }, [_c('path', {
    attrs: {
      "d": "M7 15l5 5 5-5M7 9l5-5 5 5"
    }
  })])])])]), _vm._v(" "), _c('th', {
    staticClass: "th-sort"
  }, [_c('span', {
    staticClass: "sort-col-head",
    class: _vm.tableSortHeadClass('margin'),
    attrs: {
      "role": "button",
      "tabindex": "0",
      "title": "Sort by margin %"
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.toggleTableSort('margin')
      },
      "keydown": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        $event.preventDefault();
        return _vm.toggleTableSort('margin')
      }
    }
  }, [_vm._v("Margin"), _c('span', {
    staticClass: "sort-col-icons",
    attrs: {
      "aria-hidden": "true"
    }
  }, [(_vm.tableSortKey === 'margin' && _vm.tableSortDir === 'asc') ? _c('svg', {
    staticClass: "sort-icon-filled",
    attrs: {
      "viewBox": "0 0 24 24"
    }
  }, [_c('path', {
    attrs: {
      "fill": "currentColor",
      "d": "M12 8l7 9H5z"
    }
  })]) : (_vm.tableSortKey === 'margin' && _vm.tableSortDir === 'desc') ? _c('svg', {
    staticClass: "sort-icon-filled",
    attrs: {
      "viewBox": "0 0 24 24"
    }
  }, [_c('path', {
    attrs: {
      "fill": "currentColor",
      "d": "M12 16l-7-9h14z"
    }
  })]) : _c('svg', {
    staticClass: "sort-icon-neutral",
    attrs: {
      "viewBox": "0 0 24 24",
      "fill": "none",
      "stroke": "currentColor",
      "stroke-width": "2"
    }
  }, [_c('path', {
    attrs: {
      "d": "M7 15l5 5 5-5M7 9l5-5 5 5"
    }
  })])])])]), _vm._v(" "), _c('th')])]), _vm._v(" "), _c('tbody', _vm._l((_vm.tableProducts), function(product) {
    return _c('tr', {
      key: product.productId,
      staticClass: "clickable-row",
      class: {
        'cogs-missing-row': !(product.cogs && parseFloat(product.cogs) > 0)
      },
      on: {
        "click": function($event) {
          return _vm.showProductDetails(product.productId)
        }
      }
    }, [_c('td', [_c('div', {
      staticClass: "product-thumb"
    }, [(product.largeImageUrl) ? _c('img', {
      attrs: {
        "src": product.largeImageUrl,
        "alt": ""
      }
    }) : _c('svg', {
      attrs: {
        "viewBox": "0 0 24 24",
        "fill": "none",
        "stroke": "currentColor",
        "stroke-width": "1.5"
      }
    }, [_c('rect', {
      attrs: {
        "x": "2",
        "y": "7",
        "width": "20",
        "height": "14",
        "rx": "2"
      }
    }), _c('path', {
      attrs: {
        "d": "M16 21V5a2 2 0 00-2-2h-4a2 2 0 00-2 2v16"
      }
    })])])]), _vm._v(" "), _c('td', [_c('div', {
      staticClass: "product-cell"
    }, [_c('div', {
      staticClass: "product-info"
    }, [_c('div', {
      staticClass: "product-name"
    }, [_vm._v(_vm._s(product.productTitle))]), _vm._v(" "), _c('div', {
      staticClass: "product-meta"
    }, [_c('span', {
      staticClass: "product-asin"
    }, [_vm._v(_vm._s(_vm.getAsin(product)))]), _vm._v(" "), _c('span', {
      staticClass: "market-tag"
    }, [_vm._v(_vm._s(_vm.getMarketplaceEmoji((product.marketplace || '').toUpperCase())) + " " + _vm._s(product.marketplace || '—'))])])])])]), _vm._v(" "), _c('td', [(_vm.getBuyBoxStatus(product)) ? _c('span', {
      staticClass: "bb-badge",
      class: _vm.getTableBuyBoxClass(_vm.getBuyBoxStatus(product))
    }, [_vm._v(_vm._s(_vm.getBuyBoxStatusLabel(_vm.getBuyBoxStatus(product))))]) : _c('span', {
      staticClass: "bb-badge unknown"
    }, [_vm._v("—")])]), _vm._v(" "), _c('td', [_c('span', {
      staticClass: "rating-cell",
      class: {
        'rating-unknown': _vm.ratingSummary(product.rating, product.reviewCount) === '—'
      }
    }, [_vm._v(_vm._s(_vm.ratingSummary(product.rating, product.reviewCount)))]), _vm._v(" "), (product.reviewHealthStatus === 'red') ? _c('span', {
      staticClass: "rating-alert-dot",
      attrs: {
        "title": product.reviewHealthNote || 'Review Health alert',
        "aria-label": product.reviewHealthNote || 'Review Health alert',
        "role": "img"
      }
    }) : _vm._e()]), _vm._v(" "), _c('td', [_c('div', {
      staticClass: "sales-primary"
    }, [_vm._v(_vm._s(product.salesYesterday || 0) + " units")]), _vm._v(" "), _c('div', {
      staticClass: "sales-sub"
    }, [_vm._v("Yesterday")])]), _vm._v(" "), _c('td', [_c('div', {
      staticClass: "sales-primary"
    }, [_vm._v(_vm._s(product.salesToday || 0) + " units")]), _vm._v(" "), _c('div', {
      staticClass: "sales-sub"
    }, [_vm._v("So far today")])]), _vm._v(" "), _c('td', {
      on: {
        "click": function($event) {
          $event.stopPropagation();
        }
      }
    }, [(_vm.hasProductCogs(product)) ? _c('span', {
      staticClass: "cogs-val cogs-val-editable",
      attrs: {
        "role": "button",
        "tabindex": "0",
        "title": "Edit COGS"
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          return _vm.openCogsModal(product)
        }
      }
    }, [_vm._v("$" + _vm._s(_vm.formatPrice(_vm.getProductCogs(product))))]) : _c('span', {
      staticClass: "cogs-empty"
    }, [_vm._v("Not set")])]), _vm._v(" "), _c('td', {
      on: {
        "click": function($event) {
          $event.stopPropagation();
        }
      }
    }, [(_vm.hasProductCogs(product)) ? [(_vm.getProductMargin(product) != null) ? _c('span', {
      staticClass: "margin-pill cogs-val-editable",
      class: _vm.getMarginClass(_vm.getProductMargin(product)),
      attrs: {
        "role": "button",
        "tabindex": "0",
        "title": "Edit COGS"
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          return _vm.openCogsModal(product)
        }
      }
    }, [_vm._v(_vm._s(_vm.getProductMargin(product)) + "%")]) : _c('span', {
      staticClass: "margin-pill low cogs-val-editable",
      attrs: {
        "role": "button",
        "tabindex": "0",
        "title": "Edit COGS"
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          return _vm.openCogsModal(product)
        }
      }
    }, [_vm._v("—")]), _vm._v(" "), _c('div', {
      staticClass: "table-edit-cogs-wrap"
    }, [_c('span', {
      staticClass: "add-cogs",
      on: {
        "click": function($event) {
          $event.preventDefault();
          return _vm.openCogsModal(product)
        }
      }
    }, [_vm._v("Edit COGS")])])] : _c('span', {
      staticClass: "add-cogs",
      on: {
        "click": function($event) {
          $event.preventDefault();
          return _vm.openCogsModal(product)
        }
      }
    }, [_vm._v("+ Add COGS")])], 2), _vm._v(" "), _c('td', {
      on: {
        "click": function($event) {
          $event.stopPropagation();
          $event.preventDefault();
          return _vm.openChartModal(product)
        }
      }
    }, [_c('div', {
      staticClass: "action-btn"
    }, [_c('svg', {
      attrs: {
        "viewBox": "0 0 24 24",
        "fill": "none",
        "stroke": "currentColor",
        "stroke-width": "2"
      }
    }, [_c('polyline', {
      attrs: {
        "points": "22 12 18 12 15 21 9 3 6 12 2 12"
      }
    })])])])])
  }), 0)])]), _vm._v(" "), _c('div', {
    staticClass: "ui center aligned segment products-pagination-segment"
  }, [_c('div', {
    staticClass: "ui pagination menu"
  }, [_c('a', {
    staticClass: "item",
    class: {
      disabled: _vm.gridCurrentPage === 0
    },
    on: {
      "click": function($event) {
        return _vm.tablePrevPage()
      }
    }
  }, [_c('i', {
    staticClass: "left chevron icon"
  })]), _vm._v(" "), _vm._l((Math.min(5, _vm.gridTotalPages)), function(page) {
    return _c('a', {
      key: page,
      staticClass: "item",
      class: {
        active: _vm.gridCurrentPage === _vm.getTablePageNumber(page)
      },
      on: {
        "click": function($event) {
          _vm.goToTablePage(_vm.getTablePageNumber(page))
        }
      }
    }, [_vm._v("\n              " + _vm._s(_vm.getTablePageNumber(page) + 1) + "\n            ")])
  }), _vm._v(" "), _c('a', {
    staticClass: "item",
    class: {
      disabled: _vm.gridCurrentPage >= (_vm.gridTotalPages - 1)
    },
    on: {
      "click": function($event) {
        return _vm.tableNextPage()
      }
    }
  }, [_c('i', {
    staticClass: "right chevron icon"
  })])], 2), _vm._v(" "), _c('div', {
    staticClass: "ui small message",
    staticStyle: {
      "margin-top": "10px"
    }
  }, [_vm._v("\n            Showing page " + _vm._s(_vm.gridCurrentPage + 1) + " of " + _vm._s(_vm.gridTotalPages) + "\n            (" + _vm._s(_vm.gridTotalItems) + " total products)\n          ")])])]) : _vm._e(), _vm._v(" "), (_vm.hasWorldStore && _vm.viewMode === 'grid') ? _c('div', {
    staticClass: "ui center aligned segment products-pagination-segment"
  }, [_c('div', {
    staticClass: "ui pagination menu"
  }, [_c('a', {
    staticClass: "item",
    class: {
      disabled: _vm.gridCurrentPage === 0
    },
    on: {
      "click": function($event) {
        return _vm.prevGridPage()
      }
    }
  }, [_c('i', {
    staticClass: "left chevron icon"
  })]), _vm._v(" "), _vm._l((Math.min(5, _vm.gridTotalPages)), function(page) {
    return _c('a', {
      key: page,
      staticClass: "item",
      class: {
        active: _vm.gridCurrentPage === _vm.getGridPageNumber(page)
      },
      on: {
        "click": function($event) {
          _vm.goToGridPage(_vm.getGridPageNumber(page))
        }
      }
    }, [_vm._v("\n            " + _vm._s(_vm.getGridPageNumber(page) + 1) + "\n          ")])
  }), _vm._v(" "), _c('a', {
    staticClass: "item",
    class: {
      disabled: _vm.gridCurrentPage >= (_vm.gridTotalPages - 1)
    },
    on: {
      "click": function($event) {
        return _vm.nextGridPage()
      }
    }
  }, [_c('i', {
    staticClass: "right chevron icon"
  })])], 2), _vm._v(" "), _c('div', {
    staticClass: "ui small message",
    staticStyle: {
      "margin-top": "10px"
    }
  }, [_vm._v("\n          Showing page " + _vm._s(_vm.gridCurrentPage + 1) + " of " + _vm._s(_vm.gridTotalPages) + "\n          (" + _vm._s(_vm.gridTotalItems) + " total products)\n        ")])]) : _vm._e()], 1)]), _vm._v(" "), _c('ProductDetails', {
    ref: "productDetails"
  }), _vm._v(" "), _c('ProductDetailsChartModal', {
    ref: "chartModal"
  }), _vm._v(" "), _c('ProductCostMarginModal', {
    ref: "tableProductCostMarginModal",
    on: {
      "cost-margin-updated": _vm.handleTableCostMarginUpdated
    }
  })], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-43c7358d!./~/vue-loader/lib/selector.js?type=template&index=0!./src/ProductsPage.vue
// module id = 761
// module chunks = 2